(function() { window.GUID_0a3b0ac7_a534_4dc7_af51_ad08f366239a = { getGuid: function() { return "0a3b0ac7-a534-4dc7-af51-ad08f366239a"; } }; })();
//TODO:POP
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class PopupWizard extends Controls.Popup {
            get CurrentStep() {
                return this.currentStep;
            }
            OnControlInstantiation(params) {
                super.OnControlInstantiation(params);
                let me = this;
                me.steps = {};
                me.currentStep = 1;
                this.previousButton = $("#button-" + this.ControlId + "-previous");
                this.nextButton = $("#button-" + this.ControlId + "-next");
                this.message = this.$Control.find(".popupwizard-message");
                let stepId = me.ControlId.replace(new RegExp("-", "g"), "_") + "_start";
                if (typeof CS.Controls[stepId] === "function") {
                    me.steps[1] = new CS.Controls[stepId](me);
                    me.steps[1].CheckIfCanContinue();
                    me.steps[1].OnLoad();
                }
            }
            OnDispose() {
                super.OnDispose();
                let me = this;
                this.$Control
                    .off("click." + me.UniqueNamespace)
                    .off("change.input." + me.UniqueNamespace)
                    .off("mouseup." + me.UniqueNamespace)
                    .off("keyup." + me.UniqueNamespace);
                this.$Control.remove();
            }
            // OnBindEvents overrides the parent class implementation
            OnBindEvents() {
                let me = this;
                this.$Control.offon("click." + me.UniqueNamespace, ".popupwizard-footer .button, .popupwizard-header .button", function () {
                    me.message.hide();
                    if ($(this).hasClass("next")) {
                        me.GoToNextStep();
                    }
                    else if ($(this).hasClass("previous")) {
                        window.history.back();
                        //me.GotoPreviousStep();
                    }
                    else if ($(this).hasClass("cancel")) {
                        for (let i = 0; i < me.currentStep; i++) {
                            window.history.back();
                        }
                        //window.history.go(-me.currentStep);
                        //me.Close();
                    }
                });
                this.$Control.offon("change.input." +
                    me.UniqueNamespace +
                    " mouseup." +
                    me.UniqueNamespace +
                    " keyup." +
                    me.UniqueNamespace, (e) => {
                    if (me.steps[me.currentStep] !== undefined) {
                        me.steps[me.currentStep].CheckIfCanContinue();
                    }
                });
            }
            SetNextButtonActive(status) {
                this.nextButton.prop("disabled", !status);
                if (!status) {
                    // $(this.nextButton).addClass('disabled button--disabled');
                    CS.Helper.disableButton(this.nextButton);
                }
                else {
                    // $(this.nextButton).removeClass('disabled button--disabled');
                    CS.Helper.enableButton(this.nextButton);
                }
            }
            GoToNextStep() {
                let me = this;
                this.SetNextButtonActive(false);
                let maxHeight = $(".popupwizard-content").css("max-height");
                let currentDiv = $("#" + me.controlId + "-step-" + me.currentStep);
                let stepName = "";
                if (me.steps[me.currentStep] !== undefined) {
                    stepName = me.steps[me.currentStep].NextStep;
                    me.steps[me.currentStep].OnSubmit();
                }
                let data = $("#" + me.ControlId + "-form-" + me.currentStep).serializeArray();
                data.push({ name: "StepName", value: stepName });
                let newUrl = PopupWizard.currentAjaxModalUrl.replace("/start", "/navigate");
                CS.Ajax.Post(newUrl, data, function (response) {
                    if (response.success) {
                        let newDiv = $("<div/>", {
                            id: me.controlId + "-step-" + ++me.currentStep,
                        })
                            .hide()
                            .insertAfter(currentDiv);
                        let newForm = $("<form/>", {
                            id: me.controlId + "-form-" + me.currentStep,
                        }).html(response.view);
                        newDiv.append(newForm);
                        currentDiv.hide();
                        if (parseInt(newDiv.css("height")) > parseInt(maxHeight)) {
                            newDiv.height(maxHeight);
                        }
                        newDiv.show("slide", { direction: "right" }, 200, () => {
                            newDiv.css("height", "auto");
                            let stepId = (me.ControlId + "_" + response.step).replace(new RegExp("-", "g"), "_");
                            if (typeof CS.Controls[stepId] === "function") {
                                me.steps[me.currentStep] = new CS.Controls[stepId](me);
                                me.steps[me.currentStep].OnLoad();
                                me.steps[me.currentStep].CheckIfCanContinue();
                            }
                            if (response.done) {
                                $('.popupwizard-footer [id^="button-' + me.ControlId + '-"]').hide();
                                $("#button-" + me.ControlId + "-done").show();
                            }
                            else {
                                me.previousButton.show();
                            }
                            me.$Control.focus();
                        });
                        CS.PopState.WaitForPop(me.ControlId, () => {
                            me.GotoPreviousStep();
                        });
                    }
                    else {
                        me.message.html("<label class='errormsg'>" + response.errorMessage + "</label>");
                        me.message.show();
                    }
                });
            }
            GotoPreviousStep() {
                let me = this;
                if (me.steps[me.currentStep] != undefined) {
                    me.steps[me.currentStep].OnPrevious();
                }
                let contentHeight = $(".popupwizard-content").height();
                let currentDiv = $("#" + me.controlId + "-step-" + me.currentStep);
                let previousDiv = $("#" + me.controlId + "-step-" + --me.currentStep);
                currentDiv.remove();
                //previousDiv.height(contentHeight);
                //console.log(contentHeight);
                previousDiv.show("slide", { direction: "left" }, 200, () => {
                    previousDiv.css("height", "auto");
                    console.log("auto");
                });
                if (me.currentStep == 1) {
                    this.previousButton.hide();
                }
                if (me.steps[me.currentStep]) {
                    me.steps[me.currentStep].OnPrevious();
                    me.steps[me.currentStep].OnLoad();
                    me.steps[me.currentStep].CheckIfCanContinue();
                }
            }
        }
        Controls.PopupWizard = PopupWizard;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=popup-wizard.js.map
